import React, { memo, SVGProps } from 'react'

export const BadgeOwner = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12.31 4C8.83 4 6 4.93 6 6.04V13.24C6 17.58 12.31 19.52 12.31 19.52C12.31 19.52 18.62 17.59 18.62 13.24V6.04C18.62 4.93 15.79 4 12.31 4ZM9.04 14.21V10.74L12.32 7.73L15.6 10.74V14.21H9.04Z"
      fill="currentColor"
    />
  </svg>
))
